export const SERVICE_KIND_VALUE = Object.freeze({
  TEXT: '0',
  PHONE: '1',
  VIDEO: '2'
})
